import styled from 'styled-components';

const InputWrapper = styled.div`
  &:not(:first-child) {
    margin-top: 1rem;
  }
`;

export default InputWrapper;
